import { render, staticRenderFns } from "./sdfgl.vue?vue&type=template&id=3eca415a&scoped=true&"
import script from "./sdfgl.vue?vue&type=script&lang=js&"
export * from "./sdfgl.vue?vue&type=script&lang=js&"
import style0 from "./sdfgl.vue?vue&type=style&index=0&id=3eca415a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eca415a",
  null
  
)

export default component.exports